import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Box, Button, Divider, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingPage } from '../../../common/LoadingPage';
import { changePassword, defaultApiCall } from '../../../redux/Actions/userActions';
import { showNotification } from '../../../common/Notification/ToastifyNotification';
import { useNavigate } from 'react-router-dom';
import { apiRequest } from '../../../common/common';

const DemoPaper = styled(Paper)(({ theme }) => ({
    width: 550,
    height: 'auto',
    padding: '0px 0px 25px 0px',
    margin: 'auto',
    border: '1px solid lightgray'
}));

export default function ChangePassword() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const { loading, user, error, message } = useSelector((state) => state.users);
    const [oldPassword, setOldPassword] = React.useState(null);
    const [password, setPassword] = React.useState(null);
    const [confirmPassword, setConfirmPassword] = React.useState(null);
    const [showPassword, setShowPassword] = React.useState(false);
    const [showOldPassword, setShowOldPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [errors, setErrors] = React.useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    React.useEffect(() => {
        if (error) {
            showNotification(error, 'error');
        }
        if (message) {
            navigate('/app/home/dashboard');
            showNotification(message, 'success');
            dispatch(defaultApiCall());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, message]);

    return (
        <>
            {(loading || isLoading) && (<LoadingPage isLoading={loading || isLoading} />)}
            <Grid container justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
                <Grid item xs={12} md={6}>
                    <DemoPaper variant="elevation">
                        <Box style={{ display: 'flex', justifyContent: 'end', padding: '10px 0px' }}>
                            <img src="/images/Logo.png" alt='logo' style={{ width: '30%' }} />
                        </Box>
                        <Divider />
                        <Grid container pl={2} pr={2} spacing={1} mt={1}>
                            {!token && (
                                <Grid item sm={12} md={12}>
                                    <FormControl size="small" fullWidth variant="outlined">
                                        <InputLabel htmlFor="standard-adornment-password">Current Password <span style={{ color: 'red' }}>*</span></InputLabel>
                                        <OutlinedInput
                                            label="Current Password"
                                            id="standard-adornment-password"
                                            type={showOldPassword ? 'text' : 'password'}
                                            value={oldPassword}
                                            autoComplete="new-password"
                                            onChange={(e) => {
                                                setOldPassword(e.target.value);
                                                const newErrors = errors;
                                                if (!e.target.value) {
                                                    newErrors.oldPassword = 'Please Enter Current Password';
                                                } else {
                                                    newErrors.oldPassword = '';
                                                }
                                                setErrors(newErrors);
                                            }}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label={
                                                            showOldPassword ? 'hide the password' : 'display the password'
                                                        }
                                                        onClick={() => setShowOldPassword(!showOldPassword)}
                                                        edge="end"
                                                    >
                                                        {showOldPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                        <Typography variant='body2' style={{ color: 'red' }}>{errors.oldPassword}</Typography>
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Password <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <OutlinedInput
                                        label="Password"
                                        id="standard-adornment-password"
                                        type={showPassword ? 'text' : 'password'}
                                        value={password}
                                        autoComplete="new-password"
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                            const newErrors = errors;
                                            if (!e.target.value) {
                                                newErrors.password = 'Please Enter Password';
                                            } else if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#,^()\-_+=\\/:"'<>,~`[\]{}\\|])[A-Za-z\d.@$!%*?&#,^()\-_+=\\/;:"'<>,~`[\]{}\\|]{12,}$/.test(e.target.value)) {
                                                newErrors.password = `Passwords must have at least 12 characters and contains all of the following: 
                                                uppercase letters(A-Z), 
                                                lowercase letters(a-z), 
                                                numbers(0-9) and symbols`;
                                            } else {
                                                newErrors.password = '';
                                            }
                                            setErrors(newErrors);
                                        }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showPassword ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={handleClickShowPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.password}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Confirm Password <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <OutlinedInput
                                        label="Confirm Password"
                                        id="standard-adornment-password"
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        value={confirmPassword}
                                        autoComplete="new-password"
                                        onChange={(e) => {
                                            setConfirmPassword(e.target.value);
                                            const newErrors = errors;
                                            if (!e.target.value) {
                                                newErrors.confirmPassword = 'Please Enter Confirm Password';
                                            } else if (password !== e.target.value) {
                                                newErrors.confirmPassword = 'Password and confirm Password is mismatch';
                                            } else {
                                                newErrors.confirmPassword = '';
                                            }
                                            setErrors(newErrors);
                                        }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label={
                                                        showConfirmPassword ? 'hide the password' : 'display the password'
                                                    }
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    edge="end"
                                                >
                                                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.confirmPassword}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={12}>
                                <center>
                                    <Button
                                        color='primary'
                                        size="Medium"
                                        variant='contained'
                                        onClick={async() => {
                                            const newErrors = {};
                                            if (!oldPassword && !token) {
                                                newErrors.oldPassword = 'Please Enter Current Password';
                                            }
                                            console.log(newErrors);
                                            if (!confirmPassword) {
                                                newErrors.confirmPassword = 'Please Enter Confirm Password';
                                            }
                                            if (!password) {
                                                newErrors.password = 'Please Enter Password';
                                            }

                                            setErrors(newErrors);
                                            if (Object.keys(newErrors).length === 0) {
                                                if (!token) {
                                                    const data = {
                                                        old_password: oldPassword,
                                                        new_password: password,
                                                        user_id: user.user_id,
                                                    }
                                                    dispatch(changePassword(data));
                                                } else {
                                                    setIsLoading(true);
                                                    try {
                                                        const response = await apiRequest('post', '/reset-password', {
                                                            token,
                                                            password
                                                        });
                                                        if (response.data) {
                                                            showNotification(response?.data?.message, 'success');
                                                            navigate('/');
                                                        }
                                                        setIsLoading(false);
                                                    } catch (error) {
                                                        showNotification(error?.response?.data.error || error.message, 'error');
                                                        setIsLoading(false);
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        Save
                                    </Button>
                                </center>
                            </Grid>
                        </Grid>
                    </DemoPaper>
                </Grid>
            </Grid>
        </>
    );
}